import hubapiStack from 'hub-http/stacks/hubapi';
import promiseClient from 'hub-http/adapters/promiseClient';
import { createStack } from 'hub-http';

// @ts-expect-error untyped
import { immutableResponse } from 'hub-http-contrib/middlewares/immutable';
export default promiseClient(createStack(hubapiStack, immutableResponse));